var _defs, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g3, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadimgCropped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    zoomAndPan: "magnify",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "-102.45 -57.6 1229.4 691.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "e9ca4a1919"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4c4ef51c07"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 172 21 L 762.808594 21 L 762.808594 539 L 172 539 Z M 172 21 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "7bb55ffaac"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#e9ca4a1919)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -102.45,
    width: 1229.4,
    fill: "#000000",
    y: -57.6,
    height: 691.2,
    fillOpacity: 0.35
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "333baed891"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.714844 0.488281 L 590.808594 0.488281 L 590.808594 517.675781 L 0.714844 517.675781 Z M 0.714844 0.488281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6c635baea3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 591,
    y: 0,
    height: 518
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5df01ba421"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 159.355469 8.300781 L 750 8.300781 L 750 526 L 159.355469 526 Z M 159.355469 8.300781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e85142522a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 159.355469 8.300781 L 762.808594 8.300781 L 762.808594 539.039062 L 159.355469 539.039062 Z M 159.355469 8.300781 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4c4ef51c07)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#7bb55ffaac)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 172, 21)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6c635baea3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#333baed891)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 527.804688 146.414062 L 428.347656 146.414062 C 430.484375 141.308594 431.675781 135.710938 431.675781 129.839844 L 431.675781 109.949219 C 431.675781 102.773438 429.886719 96.015625 426.769531 90.058594 C 429.886719 84.105469 431.675781 77.347656 431.675781 70.171875 L 431.675781 43.652344 C 431.675781 19.890625 412.339844 0.558594 388.582031 0.558594 L 362.0625 0.558594 C 354.886719 0.558594 348.128906 2.34375 342.171875 5.460938 C 336.214844 2.34375 329.457031 0.558594 322.285156 0.558594 L 302.394531 0.558594 C 293.847656 0.558594 285.898438 3.089844 279.191406 7.398438 C 272.484375 3.089844 264.53125 0.558594 255.988281 0.558594 L 236.097656 0.558594 C 227.550781 0.558594 219.601562 3.089844 212.894531 7.398438 C 206.1875 3.089844 198.234375 0.558594 189.6875 0.558594 L 169.800781 0.558594 C 162.625 0.558594 155.867188 2.34375 149.910156 5.460938 C 143.953125 2.34375 137.195312 0.558594 130.023438 0.558594 L 110.132812 0.558594 C 102.957031 0.558594 96.199219 2.34375 90.242188 5.460938 C 84.285156 2.34375 77.53125 0.558594 70.355469 0.558594 L 43.835938 0.558594 C 20.074219 0.558594 0.742188 19.890625 0.742188 43.652344 L 0.742188 70.171875 C 0.742188 77.347656 2.53125 84.105469 5.644531 90.058594 C 2.53125 96.015625 0.742188 102.773438 0.742188 109.949219 L 0.742188 129.839844 C 0.742188 137.011719 2.53125 143.769531 5.644531 149.726562 C 2.53125 155.683594 0.742188 162.441406 0.742188 169.617188 L 0.742188 189.507812 C 0.742188 198.050781 3.273438 206.003906 7.582031 212.710938 C 3.273438 219.417969 0.742188 227.367188 0.742188 235.914062 L 0.742188 255.804688 C 0.742188 264.347656 3.273438 272.300781 7.582031 279.007812 C 3.273438 285.714844 0.742188 293.664062 0.742188 302.210938 L 0.742188 328.730469 C 0.742188 352.492188 20.074219 371.824219 43.835938 371.824219 L 70.355469 371.824219 C 77.53125 371.824219 84.285156 370.035156 90.242188 366.921875 C 96.199219 370.035156 102.957031 371.824219 110.132812 371.824219 L 130.023438 371.824219 C 135.894531 371.824219 141.488281 370.632812 146.597656 368.5 L 146.597656 454.695312 C 146.597656 489.421875 174.851562 517.675781 209.578125 517.675781 L 527.804688 517.675781 C 562.535156 517.675781 590.789062 489.421875 590.789062 454.695312 L 590.789062 209.394531 C 590.789062 174.667969 562.535156 146.414062 527.804688 146.414062 Z M 527.804688 146.414062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5df01ba421)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M 686.546875 154.152344 L 587.089844 154.152344 C 589.226562 149.046875 590.414062 143.449219 590.414062 137.578125 L 590.414062 117.691406 C 590.414062 110.515625 588.628906 103.757812 585.511719 97.800781 C 588.628906 91.84375 590.414062 85.085938 590.414062 77.910156 L 590.414062 51.390625 C 590.414062 27.632812 571.082031 8.300781 547.320312 8.300781 L 520.800781 8.300781 C 513.628906 8.300781 506.871094 10.085938 500.914062 13.203125 C 494.957031 10.085938 488.199219 8.300781 481.023438 8.300781 L 461.136719 8.300781 C 452.589844 8.300781 444.636719 10.832031 437.929688 15.136719 C 431.222656 10.832031 423.273438 8.300781 414.726562 8.300781 L 394.835938 8.300781 C 386.292969 8.300781 378.339844 10.832031 371.632812 15.136719 C 364.925781 10.832031 356.976562 8.300781 348.429688 8.300781 L 328.539062 8.300781 C 321.367188 8.300781 314.609375 10.085938 308.652344 13.203125 C 302.695312 10.085938 295.9375 8.300781 288.761719 8.300781 L 268.875 8.300781 C 261.699219 8.300781 254.941406 10.085938 248.984375 13.203125 C 243.027344 10.085938 236.269531 8.300781 229.09375 8.300781 L 202.574219 8.300781 C 178.816406 8.300781 159.484375 27.632812 159.484375 51.390625 L 159.484375 77.910156 C 159.484375 85.085938 161.269531 91.84375 164.386719 97.800781 C 161.269531 103.757812 159.484375 110.515625 159.484375 117.691406 L 159.484375 137.578125 C 159.484375 144.753906 161.269531 151.511719 164.386719 157.46875 C 161.269531 163.425781 159.484375 170.183594 159.484375 177.355469 L 159.484375 197.246094 C 159.484375 205.792969 162.015625 213.742188 166.320312 220.449219 C 162.015625 227.15625 159.484375 235.109375 159.484375 243.65625 L 159.484375 263.542969 C 159.484375 272.089844 162.015625 280.042969 166.320312 286.746094 C 162.015625 293.453125 159.484375 301.40625 159.484375 309.953125 L 159.484375 336.46875 C 159.484375 360.230469 178.816406 379.5625 202.574219 379.5625 L 229.09375 379.5625 C 236.269531 379.5625 243.027344 377.777344 248.984375 374.660156 C 254.941406 377.777344 261.699219 379.5625 268.875 379.5625 L 288.761719 379.5625 C 294.632812 379.5625 300.230469 378.375 305.335938 376.238281 L 305.335938 462.433594 C 305.335938 497.164062 333.589844 525.417969 368.320312 525.417969 L 686.546875 525.417969 C 721.273438 525.417969 749.527344 497.164062 749.527344 462.433594 L 749.527344 217.136719 C 749.527344 182.40625 721.273438 154.152344 686.546875 154.152344 Z M 686.546875 154.152344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(6.629723, 0, 0, 6.629723, 119.704298, -64.627616)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 12.499756 21.499808 L 12.499756 17.499711 L 16.499852 17.499711 ",
    stroke: "#40396e",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(6.629723, 0, 0, 6.629723, 119.704298, -64.627616)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 22.500291 17.499711 L 25.499922 17.499711 ",
    stroke: "#40396e",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(6.629723, 0, 0, 6.629723, 119.704298, -64.627616)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 64.49983 21.499808 L 64.49983 17.499711 L 60.499734 17.499711 ",
    stroke: "#40396e",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(6.629723, 0, 0, 6.629723, 119.704298, -64.627616)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 31.499772 17.499711 L 34.499991 17.499711 ",
    stroke: "#40396e",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(6.629723, 0, 0, 6.629723, 119.704298, -64.627616)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 41.499718 17.499711 L 44.499938 17.499711 ",
    stroke: "#40396e",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(6.629723, 0, 0, 6.629723, 119.704298, -64.627616)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 51.500254 17.499711 L 54.499884 17.499711 ",
    stroke: "#40396e",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(6.629723, 0, 0, 6.629723, 119.704298, -64.627616)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 41.499718 60.499716 L 44.499938 60.499716 ",
    stroke: "#40396e",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(6.629723, 0, 0, 6.629723, 119.704298, -64.627616)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 51.500254 60.499716 L 54.499884 60.499716 ",
    stroke: "#40396e",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(6.629723, 0, 0, 6.629723, 119.704298, -64.627616)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 22.500291 60.499716 L 25.499922 60.499716 ",
    stroke: "#40396e",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(6.629723, 0, 0, 6.629723, 119.704298, -64.627616)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 31.499772 60.499716 L 34.499991 60.499716 ",
    stroke: "#40396e",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(6.629723, 0, 0, 6.629723, 119.704298, -64.627616)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 64.49983 27.500247 L 64.49983 30.499877 ",
    stroke: "#40396e",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(6.629723, 0, 0, 6.629723, 119.704298, -64.627616)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 60.499734 60.499716 L 64.49983 60.499716 L 64.49983 56.500209 ",
    stroke: "#40396e",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(6.629723, 0, 0, 6.629723, 119.704298, -64.627616)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 64.49983 36.499727 L 64.49983 39.499947 ",
    stroke: "#40396e",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(6.629723, 0, 0, 6.629723, 119.704298, -64.627616)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 64.49983 46.500263 L 64.49983 49.499893 ",
    stroke: "#40396e",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(6.629723, 0, 0, 6.629723, 119.704298, -64.627616)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 12.499756 27.500247 L 12.499756 30.499877 ",
    stroke: "#40396e",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(6.629723, 0, 0, 6.629723, 119.704298, -64.627616)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 12.499756 36.499727 L 12.499756 39.499947 ",
    stroke: "#40396e",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(6.629723, 0, 0, 6.629723, 119.704298, -64.627616)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 12.499756 56.500209 L 12.499756 60.499716 L 16.499852 60.499716 ",
    stroke: "#40396e",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(6.629723, 0, 0, 6.629723, 119.704298, -64.627616)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 12.499756 49.499893 L 12.499756 46.500263 ",
    stroke: "#40396e",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#009ccf",
    d: "M 686.546875 482.324219 L 368.320312 482.324219 C 357.335938 482.324219 348.429688 473.417969 348.429688 462.433594 L 348.429688 217.136719 C 348.429688 206.152344 357.335938 197.246094 368.320312 197.246094 L 686.546875 197.246094 C 697.53125 197.246094 706.433594 206.152344 706.433594 217.136719 L 706.433594 462.433594 C 706.433594 473.417969 697.53125 482.324219 686.546875 482.324219 Z M 686.546875 482.324219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e85142522a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(6.629723, 0, 0, 6.629723, 119.704298, -64.627616)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 85.500189 82.499952 L 37.500211 82.499952 C 35.843373 82.499952 34.499991 81.15657 34.499991 79.499732 L 34.499991 42.500166 C 34.499991 40.843329 35.843373 39.499947 37.500211 39.499947 L 85.500189 39.499947 C 87.157027 39.499947 88.499819 40.843329 88.499819 42.500166 L 88.499819 79.499732 C 88.499819 81.15657 87.157027 82.499952 85.500189 82.499952 Z M 85.500189 82.499952 ",
    stroke: "#40396e",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9eeff",
    d: "M 549.839844 411.167969 C 549.546875 411.167969 549.25 411.117188 548.96875 411.011719 C 548.316406 410.769531 547.792969 410.273438 547.519531 409.628906 L 530.5 369.40625 L 506.273438 393.636719 C 505.554688 394.355469 504.46875 394.574219 503.527344 394.179688 C 502.585938 393.792969 501.972656 392.871094 501.972656 391.851562 L 501.972656 270.921875 C 501.972656 269.917969 502.5625 269.015625 503.480469 268.613281 C 504.394531 268.214844 505.464844 268.390625 506.199219 269.066406 L 591.859375 348.011719 C 592.574219 348.671875 592.847656 349.679688 592.558594 350.609375 C 592.269531 351.539062 591.472656 352.21875 590.507812 352.355469 L 558.523438 356.925781 L 575.660156 395.878906 C 576.203125 397.105469 575.683594 398.542969 574.480469 399.144531 L 550.96875 410.902344 C 550.613281 411.078125 550.226562 411.167969 549.839844 411.167969 Z M 549.839844 411.167969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadimgCropped);
export default __webpack_public_path__ + "static/media/uploadimg-cropped.5008f6cf0f3c160bc591230ebf512502.svg";
export { ForwardRef as ReactComponent };